/** Client capability helpers for the post-disclosure setup tips. */

export function IsStandaloneDisplay() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches
    || window.matchMedia('(display-mode: fullscreen)').matches
    || window.navigator.standalone === true
  );
}

export function IsIosLike() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/i.test(ua)) return true;
  // iPadOS desktop UA still needs Home Screen for Web Push.
  return navigator.platform === 'MacIntel' && Number(navigator.maxTouchPoints || 0) > 1;
}

export function IsAndroidLike() {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent || '');
}

export function BrowserPushReady() {
  return (
    typeof window !== 'undefined'
    && 'serviceWorker' in navigator
    && 'PushManager' in window
    && 'Notification' in window
  );
}

/**
 * Capability profile (not a strict OS label).
 * iPhone Safari tabs need Add to Home Screen for Conga web push.
 * Android/Chrome (and most desktop Chrome) can subscribe in a normal tab.
 */
export function GetExperienceProfile() {
  const standalone = IsStandaloneDisplay();
  const ios = IsIosLike();
  const android = IsAndroidLike();
  const push = BrowserPushReady();

  if (standalone) {
    return { id: 'standalone', title: 'Home Screen mode', ios, android, push, standalone };
  }
  if (ios && !push) {
    return { id: 'ios-needs-homescreen', title: 'iPhone setup', ios, android, push, standalone };
  }
  if (android) {
    return { id: 'android-chrome', title: 'Android setup', ios, android, push, standalone };
  }
  if (push) {
    return { id: 'desktop-push', title: 'Desktop setup', ios, android, push, standalone };
  }
  return { id: 'limited', title: 'Quick setup', ios, android, push, standalone };
}
